module.exports = __webpack_public_path__ + "img/password.dbd56e04.svg";